import React, { useState, useMemo } from 'react';
import ReportFilter from './ReportFilter';
import SpinnerController from '../spinnerController/Spinner';
import Pagination from './Pagination';

const ReportTable = ({ project, handleFilter, ticketDetails, setProject, filterError, years, setYear, setQuarter }) => {
  
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedTickets = useMemo(() => {
    if (!ticketDetails.tickets) return [];

    const sortableItems = [...ticketDetails.tickets];

    sortableItems.sort((a, b) => {
      if (a[sortConfig.key] === undefined || b[sortConfig.key] === undefined) {
        return 0;
      }

      const aValue = a[sortConfig.key] || ''; 
      const bValue = b[sortConfig.key] || ''; 

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    return sortableItems;
  }, [ticketDetails.tickets, sortConfig]);


  const filteredTickets = sortedTickets.filter(ticket => {
    const ticketStr = ticket.ticket ? ticket.ticket.toLowerCase() : '';
    const emailStr = ticket.email ? ticket.email.toLowerCase() : '';
    const query = searchQuery.toLowerCase();
    return ticketStr.includes(query) || emailStr.includes(query); 
  });

  return (
    <div className='max-w-6xl flex flex-col px-10 justify-center container mx-auto pt-10' style={{ maxWidth: '1400px' }}>
      <div className='w-full text-center mb-4'>
        <h1 className='text-2xl font-bold text-gray-700'>Generic Report</h1>
      </div>

      
      

      <div className="table-wrp block max-h-[41rem] overflow-x-auto relative shadow-md sm:rounded-lg bg-gray-500 w-full">
        <table className="w-full text-sm text-center text-gray-500">
          <caption className="sticky top-0 p-5 text-lg font-semibold text-left text-gray-700 bg-white border-b-2 border-gray-500">
            <div className="flex items-center justify-center aligncenter justify-between">
              <ReportFilter project={project} handleFilter={handleFilter} setProject={setProject} setYear={setYear} years={years} setQuarter={setQuarter} />
              {/* <div className="mb-4 flex justify-center">
                  <input
                    type="text"
                    className="w-60 p-2 border border-gray-300 rounded"
                    placeholder="Search by Ticket or Email"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} 
                  />
                </div> */}

                <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="text"
                      className="w-64 p-0.5 border border-gray-300 rounded text-center pl-10 "
                      placeholder="Search by name or email"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
            </div>
           
            <div>
              {filterError && (
                <h6 className="pt-2 text-xs font-sm text-red-700">* {filterError}</h6>
              )}
            </div>
          </caption>
          <thead className="sticky top-[88px] text-xs text-gray-900 uppercase bg-white border-b-2 border-gray-500">
            <tr>
              <th scope="col" className="py-3 px-6">Index</th>
              <th scope="col" className="py-3 px-6">Ticket</th>
              <th scope="col" className="py-3 px-6">Status</th>
              <th
                scope="col" className="py-3 px-6 cursor-pointer"
                onClick={() => requestSort('email')}
              >
                Escalated By {sortConfig.key === 'email' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </th>
              <th
                scope="col" className="py-3 px-6 cursor-pointer"
                onClick={() => requestSort('createdAt')}
              >
                Created at {sortConfig.key === 'createdAt' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
              </th>
            </tr>
          </thead>
          <tbody>
            {!ticketDetails.tickets
              ? <tr key="loading">
                  <td colSpan="5" className="bg-gray-50 p-4">
                    <div className="flex justify-center">
                      <SpinnerController />
                    </div>
                  </td>
                </tr>
              : !filteredTickets.length
                ? <tr key="nodata">
                    <td className="bg-gray-50 p-4" colSpan="5">No data available</td>
                  </tr>
                : <>
                    {filteredTickets.map((ticket, i) => (
                      <tr key={i} className="bg-white text-gray-900 border-b hover:bg-myellow">
                        <th scope="row" className="py-4 px-6">
                          {i + 1}
                        </th>
                        <td className="py-4 px-6 bg-myellow font-medium font-semibold text-gray-900">
                          {ticket.ticket}
                        </td>
                        <td className="py-4 px-6">
                          {ticket.isOpened ? "Open" : "Closed"}
                        </td>
                        <td className="py-4 px-6 font-medium font-semibold text-gray-900">
                          {ticket.email}
                        </td>
                        <td className="py-4 px-6">
                          {new Date(ticket.createdAt).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </>
            }
          </tbody>
        </table>
      </div>
      <Pagination project={project} pageNo={ticketDetails?.tickets?.length ? ticketDetails?.tickets?.length : 0} length={ticketDetails.tLength} />
    </div>
  );
};

export default ReportTable;